"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var EmptyStarIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EmptyStarIcon, _React$PureComponent);

  function EmptyStarIcon() {
    _classCallCheck(this, EmptyStarIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(EmptyStarIcon).apply(this, arguments));
  }

  _createClass(EmptyStarIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'empty-star-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M8.20122715,6.649 C8.09622715,6.752 8.04822715,6.899 8.07322715,7.045 L8.51322715,9.611 L6.20822715,8.399 C6.07722715,8.331 5.92222715,8.331 5.79222715,8.399 L3.48722715,9.611 L3.92722715,7.045 C3.95222715,6.899 3.90422715,6.752 3.79922715,6.649 L1.93422715,4.831 L4.51122715,4.457 C4.65722715,4.435 4.78222715,4.344 4.84722715,4.212 L6.00022715,1.878 L7.15222715,4.212 C7.21822715,4.344 7.34322715,4.435 7.48922715,4.457 L10.0662272,4.831 L8.20122715,6.649 Z M11.7662272,5.121 C11.9782272,4.916 12.0532272,4.613 11.9622272,4.332 C11.8702272,4.05 11.6322272,3.85 11.3392272,3.807 L8.25222715,3.359 C8.17322715,3.347 8.10722715,3.298 8.07222715,3.227 L6.69122715,0.43 C6.56122715,0.165 6.29622715,0 5.99922715,0 C5.70422715,0 5.43922715,0.165 5.30822715,0.43 L3.92822715,3.227 C3.89322715,3.298 3.82622715,3.347 3.74722715,3.359 L0.660227152,3.807 C0.368227152,3.85 0.130227152,4.05 0.0382271519,4.332 C-0.0527728481,4.613 0.0212271519,4.916 0.233227152,5.121 L2.46722715,7.298 C2.52422715,7.354 2.55022715,7.433 2.53622715,7.511 L2.01022715,10.586 C1.95922715,10.877 2.07622715,11.166 2.31522715,11.339 C2.45022715,11.438 2.60922715,11.487 2.76822715,11.487 C2.89022715,11.487 3.01422715,11.459 3.12722715,11.398 L5.88822715,9.947 C5.95522715,9.91 6.04122715,9.909 6.11222715,9.947 L8.87322715,11.397 C9.13222715,11.536 9.44522715,11.514 9.68422715,11.339 C9.92422715,11.166 10.0412272,10.877 9.99022715,10.587 L9.46322715,7.51 C9.45022715,7.433 9.47522715,7.354 9.53322715,7.298 L11.7662272,5.121 Z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return EmptyStarIcon;
}(_react.default.PureComponent);

exports.default = EmptyStarIcon;
EmptyStarIcon.defaultProps = {
  color: 'inherit'
};
EmptyStarIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};